import dayjs from "dayjs";
import { type OrderLogReadDto } from "@/config/apiClient";
import { type OrderItemLogActionTypeEnum } from "@/config/apiClient.types";

// Find the last log with the given action type after the given reference logs
export const findLastLogAfter = (
  orderItemLogs: OrderLogReadDto[],
  actionType: OrderItemLogActionTypeEnum,
  referenceLogs?:
    | OrderLogReadDto
    | (OrderLogReadDto | undefined | null)[]
    | undefined
    | null,
  fallbackIfNoRef: boolean = true,
  additionalPredicate?: (log: OrderLogReadDto) => boolean
) => {
  // Filter out undefined and null reference logs
  const validReferenceLogs = (
    Array.isArray(referenceLogs) ? referenceLogs : [referenceLogs]
  ).filter((r): r is OrderLogReadDto => !!r);

  // Get the latest reference log date if there are any reference logs.
  const latestBarrierDate =
    validReferenceLogs.length > 0
      ? validReferenceLogs
          .map((r) => dayjs(r.createdAt))
          .reduce((max, curr) => (curr.isAfter(max) ? curr : max))
      : null;

  return orderItemLogs.findLast((log) => {
    const isActionMatch = log.actionType === actionType;
    const isPredicateValid = additionalPredicate?.(log) ?? true;

    const isDateValid = latestBarrierDate
      ? dayjs(log.createdAt).isAfter(latestBarrierDate)
      : fallbackIfNoRef;

    return isActionMatch && isPredicateValid && isDateValid;
  });
};
